<template>
  <div class="app-layout" :class="{ 'is-collapsed': sidebarCollapsed }">
    <aside class="sidebar glass-panel">
      <div class="brand">
        <div class="brand-mark">
          <img src="@/assets/logo/1024.png" alt="heliumflash-tools">
        </div>
        <div class="brand-copy">
          <div class="brand-title">heliumflash-tools</div>
          <div class="brand-subtitle">专用工具台</div>
        </div>
      </div>

      <button
        class="collapse-btn"
        type="button"
        :title="sidebarCollapsed ? '展开菜单' : '折叠菜单'"
        @click="toggleSidebar"
      >
        <span>{{ sidebarCollapsed ? '›' : '‹' }}</span>
      </button>

      <nav class="side-menu">
        <template v-for="item in menuTree">
          <router-link
            v-if="!item.children.length"
            :key="item.id"
            class="menu-link"
            :to="item.routePath"
          >
            <span class="menu-icon">{{ item.icon }}</span>
            <span class="menu-text">{{ item.menuName }}</span>
          </router-link>

          <div v-else :key="item.id" class="menu-group">
            <div class="menu-title">
              <span class="menu-icon">{{ item.icon }}</span>
              <span class="menu-text">{{ item.menuName }}</span>
            </div>
            <router-link
              v-for="child in item.children"
              :key="child.id"
              class="menu-link menu-child"
              :to="child.routePath"
              :title="child.menuName"
            >
              <span class="menu-icon">{{ child.icon }}</span>
              <span class="menu-text">{{ child.menuName }}</span>
            </router-link>
          </div>
        </template>
      </nav>

      <button class="logout-btn" type="button" @click="logout">
        <span>⏻</span>
        <span class="menu-text">退出登录</span>
      </button>
    </aside>

    <main class="main-area">
      <section class="content-wrap">
        <router-view/>
      </section>
    </main>
  </div>
</template>

<script>
import { buildMenuTree, getAvailableMenuList } from '@/utils/menu'

const SIDEBAR_COLLAPSED_KEY = 'hf_sidebar_collapsed'

export default {
  name: 'MainLayout',
  data() {
    return {
      menuList: getAvailableMenuList(),
      sidebarCollapsed: window.localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === '1'
    }
  },
  computed: {
    menuTree() {
      return buildMenuTree(this.menuList)
    }
  },
  methods: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed
      window.localStorage.setItem(SIDEBAR_COLLAPSED_KEY, this.sidebarCollapsed ? '1' : '0')
    },
    logout() {
      window.localStorage.removeItem('oauthToken');
      window.localStorage.removeItem('menuList');
      window.localStorage.removeItem('userInfo');
      window.sessionStorage.removeItem('loginToken');
      this.$router.replace('/login');
    }
  }
}
</script>

<style scoped>
.app-layout {
  position: relative;
  display: grid;
  grid-template-columns: 236px minmax(0, 1fr);
  min-height: 100vh;
  padding: 0;
  gap: 0;
}

.app-layout::before {
  position: fixed;
  inset: 0;
  pointer-events: none;
  content: "";
  background:
    linear-gradient(rgba(15, 23, 42, .025) 1px, transparent 1px),
    linear-gradient(90deg, rgba(15, 23, 42, .025) 1px, transparent 1px);
  background-size: 48px 48px;
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, .42), transparent 80%);
}

.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  width: 236px;
  height: 100vh;
  overflow: hidden;
  border: 0;
  border-right: 1px solid rgba(15, 23, 42, .06);
  border-radius: 0;
  background: rgba(218, 239, 250, .76);
  box-shadow: none;
  padding: 14px 10px;
}

.app-layout.is-collapsed {
  grid-template-columns: 76px minmax(0, 1fr);
}

.app-layout.is-collapsed .sidebar {
  width: 76px;
  padding: 14px 10px;
}

.app-layout.is-collapsed .brand-copy,
.app-layout.is-collapsed .menu-text,
.app-layout.is-collapsed .menu-group,
.app-layout.is-collapsed .logout-btn .menu-text {
  display: none;
}

.app-layout.is-collapsed .menu-link,
.app-layout.is-collapsed .menu-title,
.app-layout.is-collapsed .logout-btn {
  justify-content: center;
  padding-left: 0;
  padding-right: 0;
}

.app-layout.is-collapsed .menu-child {
  margin-left: 0;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 8px 20px;
}

.brand-mark {
  position: relative;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: rgba(255, 255, 255, .42);
  overflow: hidden;
  flex: 0 0 34px;
}

.brand-mark img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.brand-title {
  color: #1d2939;
  font-size: 15px;
  font-weight: 800;
}

.brand-subtitle {
  margin-top: 3px;
  color: #667085;
  font-size: 12px;
}

.collapse-btn {
  display: grid;
  place-items: center;
  width: 100%;
  height: 34px;
  margin: 0 0 10px;
  border: 1px solid rgba(148, 163, 184, .18);
  border-radius: 12px;
  background: rgba(255, 255, 255, .42);
  color: #344054;
  cursor: pointer;
  font-size: 18px;
  font-weight: 800;
}

.collapse-btn:hover {
  border-color: rgba(15, 23, 42, .18);
  background: rgba(255, 255, 255, .68);
}

.side-menu {
  flex: 1;
  overflow-y: auto;
}

.menu-group {
  margin: 12px 0 4px;
}

.menu-title,
.menu-link {
  display: flex;
  align-items: center;
  gap: 9px;
  min-height: 38px;
  border-radius: 12px;
  color: #344054;
  font-size: 14px;
  text-decoration: none;
  padding: 0 12px;
}

.menu-title {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}

.menu-link {
  margin: 3px 0;
  font-weight: 700;
}

.menu-link:hover,
.menu-link.router-link-active {
  background: rgba(255, 255, 255, .62);
  color: #101828;
}

.menu-child {
  margin-left: 28px;
}

.menu-icon {
  display: inline-grid;
  width: 18px;
  place-items: center;
  color: inherit;
}

.menu-text {
  min-width: 0;
}

.logout-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 42px;
  border: 1px solid rgba(148, 163, 184, .22);
  border-radius: 12px;
  background: rgba(255, 255, 255, .54);
  color: #344054;
  cursor: pointer;
}

.logout-btn:hover {
  border-color: rgba(15, 23, 42, .18);
  color: #101828;
}

.main-area {
  position: relative;
  z-index: 1;
  min-width: 0;
  grid-column: 2;
  padding: 0 20px 28px;
}

.content-wrap {
  width: 100%;
  max-width: none;
  margin: 0 auto;
  padding: 18px 0 0;
}

.app-layout.is-collapsed .main-area {
  padding-left: 16px;
}

@media (max-width: 920px) {
  .app-layout {
    grid-template-columns: 1fr;
    padding: 12px;
  }

  .app-layout.is-collapsed {
    grid-template-columns: 1fr;
  }

  .sidebar {
    position: relative;
    top: 0;
    width: 100%;
    height: auto;
    border-radius: 18px;
  }

  .main-area {
    grid-column: 1;
    padding: 0;
  }

  .app-layout.is-collapsed .sidebar {
    width: 100%;
  }
}
</style>
